import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZGE9zx4gf8Mw-9Puu4JP364FiOIqBi4Y",
  authDomain: "streamdash-12aa9.firebaseapp.com",
  projectId: "streamdash-12aa9",
  storageBucket: "streamdash-12aa9.firebasestorage.app",
  messagingSenderId: "129263650364",
  appId: "1:129263650364:web:ecfb4960dae83b7b4b6539",
  measurementId: "G-QE46VJG3V8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

export default app;